import type { ApiRoute, NoPathParams, NoResponse } from "../../api"
import type { SetSelectedRoofColorBody } from "../../common/colors/roofColor/SetSelectedRoofColorBody"

export interface SetSelectedRoofColorQueryParams {
	"inventory-id": string
}

export const setSelectedRoofColorRoute: ApiRoute<
	NoPathParams,
	SetSelectedRoofColorQueryParams,
	SetSelectedRoofColorBody,
	NoResponse
> = {
	buildUrl: () => "/colors/roof-color/selected",
	method: "post",
	path: "/colors/roof-color/selected",
}
